import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import DashboardBank from '../../DashboardBank';

import Orgcom from './_org/Orgcom';
import Profile from './_profile/Profile';
import ListSTS from './_sts/ListSTS'
// import STSList from './_sts/STSList'
import STSList from './../admin/_sts/STSList'

const BankView = () => (
   <div>
      <Switch>             
         <Route path={"/c/dashboard"} name="dashboard" component={DashboardBank} />
         <Route path={"/c/sts"} name="sts" component={STSList} />
         <Route path={"/c/realisasi"} name="realisasi" component={ListSTS} />
         <Route path={"/c/org"} name="org" component={Orgcom} />         
         <Route path={"/c/profile"} name="profile" component={Profile} />         
         <Route path={"/c/dashboard"} name="sts-verifikasi" component={DashboardBank} />
         <Redirect from="/c" to="/c/dashboard" />
      </Switch>
   </div>
);

export default BankView;



// WEBPACK FOOTER //
// ./src/components/Content/views/bank/bank.view.js